/**
 * Resource decorator.
 */
export function Resource(name) {
    // eslint-disable-next-line @typescript-eslint/ban-types
    return function (constructor) {
        constructor.prototype.route = name;
    };
}
//# sourceMappingURL=resource.js.map